import axios from '../../util/axios';
import router from '../../router';
import api from '../../util/api';
import { Message } from 'element-ui';
import { resetVuex,dealInterfaceMenu } from '@/util/util';
const default_state = {
  menuLeft: [],
  userInfo: {},
  shopInfo: {},
  relationMenu: [],
  loadingFlag: false,
  store_type: '',
  skip_type: -1,
  token: '',
  is_supplier:false
};
const state = {
  menuLeft: [],
  userInfo: {},
  shopInfo: {},
  relationMenu: [],
  loadingFlag: false,
  supplier_type_list: [3, 4, 5],
  skip_type: -1,
  store_type: '',
  token: '',
  is_supplier: false,
};

const mutations = {
  resetState(state) {
    let data = Object.assign({}, default_state);
    for (let i in data) {
      state[i] = data[i];
    }
  },
  setRoutes(state, data) {
    state.menuLeft = data;
  },
  setRelationMenu(state, data) {
    state.relationMenu = data;
  },
  getUserInfo(state, data) {
    state.userInfo = data || {};
  },
  getShopInfo(state, data) {
    state.shopInfo = data || {};
  },
  changeLoadingFlag(state, data) {
    state.loadingFlag = data;
  },
  setStoreType(state, data) {
    state.store_type = data;
  },
  setToken(state, data) {
    state.token = data;
  },
  setSkipType(state, data) {
    state.skip_type = data;
  },
  setIsSupplier(state, data) {
    state.is_supplier = data;
  },
  dealStoreInfo(state,info){
    state.store_type = info.store_type
    let is_supplier = state.supplier_type_list.findIndex(i => i == info.store_type)
    state.is_supplier = is_supplier !== -1
    state.skip_type = info.skip_type
  },
};

const actions = {
  outLogin() {
    axios.post(api.user.logout).then((res) => {
      if (res.code == 0) {
        Message({
          message: '退出登录成功',
          type: 'success',
        });
        resetVuex();
        sessionStorage.removeItem('token');
        router.push('/login');
      } else {
        Message.error(res.msg);
      }
    });
  },
  getUserInfo({ commit ,state}) {
    axios.post(api.user.userInfo).then((res) => {
      if (!res) return
      if (res.code == 0) {
        commit('getUserInfo', res.result);
       
      } else {
        Message.error(res.msg);
      }
    });
  },
  getShopInfo({ commit }) {
    axios.post(api.user.shopInfo).then((res) => {
      if (res.code == 0) {
        commit('getShopInfo', res.result);
      } else {
        Message.error(res.msg);
      }
    });
  },
  get_menu({ commit,state }, data = {}) {
    axios.post(api.user.getMenu).then((res) => {
      if (res.code == 0) {
        let arr = [];
        res.result.map(menu => {
          arr.push(dealInterfaceMenu(menu, {}))
        })
        commit('setRoutes', arr);
        data.success();
      } else {
        Message.error(res.msg);
      }
    });
  },
  isSupplier(context) {
    let s_type = context.state.store_type || localStorage.getItem('s_type')
    let is_supplier = context.state.supplier_type_list.findIndex(i => i == s_type) != -1
    return is_supplier
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
